import { Mapper } from '../base-mapper';
import { NIOSH_RISKS } from '@/utils/constants';
import type { NioshReport } from '@/types/Niosh';
import { GetNioshReportResponseDTO } from '@/core/dto/niosh';

export class NioshReportMapper implements Mapper<NioshReport> {
	constructor(private readonly data: GetNioshReportResponseDTO) {}

	private getResult(): number {
		const riskIndex = Object.keys(NIOSH_RISKS).findIndex((key) => key === this.data.risk);
		const result = riskIndex + 1;
		return result;
	}

	toDomain(): NioshReport {
		return {
			...this.data,
			result: this.getResult(),
			risk: this.data.risk ?? '',
			coupling: this.data.coupling ?? '',
			duration: this.data.duration ?? '',
			frequency: this.data.frequency ? Number(this.data.frequency) : 0
		};
	}
}
